export default __webpack_public_path__ + "static/media/dragdrop.92016966.png";